import AsyncStorage from "@react-native-async-storage/async-storage";

import { OnboardingFunnelEvent, OnboardingFunnelStep } from "../types/domain";

const FUNNEL_KEY = "wehonor-funnel-v1";

export async function trackFunnelStep(
  step: OnboardingFunnelStep,
  domain: string,
  metadata?: Record<string, unknown>,
): Promise<void> {
  const event: OnboardingFunnelEvent = {
    step,
    domain,
    timestamp: new Date().toISOString(),
    metadata,
  };
  const raw = await AsyncStorage.getItem(FUNNEL_KEY).catch(() => null);
  const events: OnboardingFunnelEvent[] = raw ? JSON.parse(raw) : [];
  events.push(event);
  await AsyncStorage.setItem(FUNNEL_KEY, JSON.stringify(events)).catch(() => undefined);
}

export async function getFunnelEvents(): Promise<OnboardingFunnelEvent[]> {
  const raw = await AsyncStorage.getItem(FUNNEL_KEY).catch(() => null);
  return raw ? JSON.parse(raw) : [];
}
